import client from "./client";

const LessonTimeService = {};

LessonTimeService.get = function () {
  return client.get(`/schedule`);
};

LessonTimeService.create = function (data) {
  return client.post(`/schedule`, data);
};

LessonTimeService.update = function (id, data) {
  return client.put(`/schedule/${id}`, data);
};

LessonTimeService.delete = function (id) {
  return client.del(`/schedule/${id}`);
};

export default LessonTimeService;
